import { Checkbox } from 'components'
import { connect } from 'react-redux'

import { toggleItem } from '../actions'

const mapStateToProps = (state, ownProps) => ({
  isChecked: state.search.selectedStores.some(store => store.storeId === ownProps.storeId),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  isChecked: stateProps.isChecked,
  onChange: () => dispatchProps.toggleItem(ownProps.data),
})

export default connect(mapStateToProps, { toggleItem }, mergeProps)(Checkbox)
